import { render, staticRenderFns } from "./city-project.vue?vue&type=template&id=52156d72"
import script from "./city-project.vue?vue&type=script&lang=js"
export * from "./city-project.vue?vue&type=script&lang=js"
import style0 from "./city-project.vue?vue&type=style&index=0&id=52156d72&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52156d72')) {
      api.createRecord('52156d72', component.options)
    } else {
      api.reload('52156d72', component.options)
    }
    module.hot.accept("./city-project.vue?vue&type=template&id=52156d72", function () {
      api.rerender('52156d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/city-project.vue"
export default component.exports